<template>
  <div>
    <CompilationsView />
    <AppFooter />
  </div>
</template>

<script>
import CompilationsView from '@/components/views/CompilationsView/CompilationsView';
import AppFooter from '@/components/views/AppFooter/AppFooter.vue';
import pageCommonMixin from '@/components/mixins/pageCommonMixin';

export default {
  name: 'CompilationPage',
  components: {
    CompilationsView,
    AppFooter
  },
  mixins: [pageCommonMixin]
};
</script>

<style lang="less"></style>
